var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { injectable } from 'inversify';
import { GameConfiguratorSingleton } from './GameConfiguratorSingleton';
import { CELL_SIZE, TOOLBAR_HEIGHT } from '@static/game';
import { Bonus } from '@components/Bonus';
import { collision } from '@utils/collision';
var BonusServiceImpl = /** @class */ (function () {
    function BonusServiceImpl() {
        var _this = this;
        this.createBonus = function () {
            var bonusesAmounts = [10, 20, 30, 40];
            var amount = bonusesAmounts[Math.floor(Math.random() * bonusesAmounts.length)];
            var xPosition = Math.random() * (_this._gameConfigurator.canvasWidth - CELL_SIZE);
            var yPosition = Math.floor((Math.random() *
                (_this._gameConfigurator.canvasHeight - TOOLBAR_HEIGHT)) /
                CELL_SIZE +
                1) *
                CELL_SIZE +
                CELL_SIZE / 2;
            _this._bonuses.push(new Bonus(xPosition, yPosition, amount));
        };
        var bonusCreationInterval = 10000;
        this._gameConfigurator = GameConfiguratorSingleton.getInstance();
        this._bonuses = [];
        setInterval(this.createBonus, bonusCreationInterval);
    }
    BonusServiceImpl.prototype.removeBonusByIndex = function (index) {
        this._bonuses.splice(index, 1);
    };
    BonusServiceImpl.prototype.drawBonuses = function () {
        var _this = this;
        this._bonuses.forEach(function (bonus, index) {
            bonus.move();
            bonus.draw();
            if (bonus && collision(_this._gameConfigurator.mouse, bonus)) {
                _this._gameConfigurator.balance =
                    _this._gameConfigurator.balance + bonus.amount;
                _this.removeBonusByIndex(index);
            }
        });
    };
    BonusServiceImpl = __decorate([
        injectable()
    ], BonusServiceImpl);
    return BonusServiceImpl;
}());
export { BonusServiceImpl };
